import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionStatusComponent } from './connection-status.component';
import { VaBadgeModule } from '@vendasta/uikit';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ConnectionStatusComponent],
  imports: [CommonModule, VaBadgeModule, TranslateModule],
  exports: [ConnectionStatusComponent],
})
export class ConnectionStatusModule {}
